import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { POST_SELECTED_WHEN } from "../../store/action";
import { dayPlusOne } from "../functions/dateFunctions";
import "../styles/layout.css";

// image importation

import { configureCrisp } from "../../utils/crispConfig";
import SelectUserOrder from "../elements/select_user_order";

const LayoutUserOrders = () => {

  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);

  let userData = useSelector((state) => state.user);

  const dispatch = useDispatch();

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {
    const tday = dayPlusOne();
    if (selectedWhen === null || selectedWhen < tday) {
      WhenDate(tday);
    }

  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  return (
    <div className="global-block">
      <div className="full-block">
        <SelectUserOrder lang={selectedLang} user={userData} />
        {/* Tu dois ajouter tout les autre compasant du projet ici */}
      </div>
    </div>
  );
};

export default LayoutUserOrders;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});
